import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { InvitedAuthService } from './invited-auth.service';

export const invitedAuthGuard: CanActivateFn = () => {
  const auth = inject(InvitedAuthService);
  const router = inject(Router);
  return auth.isLoggedIn ? true : router.createUrlTree(['/invited/login']);
};
